import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectActiveSort,
  selectCurrentMode,
  selectIsAtLeastOneItineraryApix,
  selectIsComputingDone,
} from '../../store/itinerary/itinerary.selectors'
import { MULTIPATH_MODE_TC } from '../../store/itinerary/itinerary.constants'
import s from './ItineraryBonjourRedirection.less'
import bonjourIcon from './bonjour_icon.svg'
import T from '../i18n/T'
import { selectArrivalStep, selectDepartureStep } from './steps/steps.selectors'
import { selectIsFrenchLanguage } from '../../store/navigation/navigation.selectors'
import { createCustomSelector } from '../utils/react-reselect'

export const selectShouldShowBonjourRedirection = createCustomSelector(
  selectCurrentMode,
  selectIsComputingDone,
  selectDepartureStep,
  selectArrivalStep,
  selectActiveSort,
  selectIsAtLeastOneItineraryApix,
  (currentMode, isComputingDone, departureStep, arrivalStep, activeSort, isAtLeastOneItineraryApix) =>
    currentMode === MULTIPATH_MODE_TC &&
    isComputingDone &&
    departureStep?.label !== arrivalStep?.label &&
    !activeSort &&
    isAtLeastOneItineraryApix
)

const ItineraryBonjourRedirection = () => {
  const isFrenchLocale = useSelector(selectIsFrenchLanguage)
  const shouldShowBonjourRedirection = useSelector(selectShouldShowBonjourRedirection)
  const localeUrlString = isFrenchLocale ? '' : 'en/'

  if (!shouldShowBonjourRedirection) return <></>

  const redirectLink = `https://www.bonjour-ratp.fr/${localeUrlString}itineraires/`

  return (
    <div className={s.linkContainer}>
      <img src={bonjourIcon} className={s.icon} alt="Logo Bonjour RATP" />
      <T id="itinerary.result.tc.bonjour.redirection" />{' '}
      <a className={s.link} href={redirectLink} target="_blank" rel="noreferrer">
        Bonjour RATP
      </a>
    </div>
  )
}

export default ItineraryBonjourRedirection
